// extracted by mini-css-extract-plugin
export default {"customSpinner":"BRpRJ7dhvdnjZ65zOdeb","ldsRing":"ZFUQt3iXyeaSoVtrim7e","white":"lg4cnbdm9U5P52Wu208Q"};